module.exports = __webpack_public_path__ + "img/icon-sources.cdad353b.svg";